
<div class="columns h-100 is-justify-content-center is-align-items-center">
  <div class="column is-one-third"></div>
  <div [ngClass]="{'card has-round-border has-box-shadow': !loadingBatchDownload}" class="column has-text-centered">
    <div class="columns">
      <ng-container *ngIf="errorWhileLoading">
        <div class="column has-text-centered">
          <p>Fehler beim laden des Downloads.</p>
        </div>
      </ng-container>

      <ng-container *ngIf="batchDownload && !loadingBatchDownload && !errorWhileLoading">
        <div class="column">
          <div class="svg-container mt-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="128.999" height="128.999" viewBox="0 0 128.999 128.999">
              <g id="Icon_feather-download" data-name="Icon feather-download" transform="translate(3 3)">
                <path id="Pfad_101" data-name="Pfad 101" d="M127.5,22.5V49.833A13.667,13.667,0,0,1,113.832,63.5H18.167A13.667,13.667,0,0,1,4.5,49.833V22.5" transform="translate(-4.5 59.499)" fill="none" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                <path id="Pfad_102" data-name="Pfad 102" d="M10.5,15,44.666,49.166,78.833,15" transform="translate(16.833 32.833)" fill="none" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                <path id="Pfad_103" data-name="Pfad 103" d="M18,86.5V4.5" transform="translate(43.5 -4.5)" fill="none" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
              </g>
            </svg>
          </div>


          <div>
            <p class="is-bold mt-5" style="font-size: 25px; color: #35566E">Wir sind startklar</p>
          </div>

          <div class="mt-5">
            <p *ngIf="!isDateExpired()" class="color-gray">Die Übertragung läuft am {{batchDownload.expirationDate | date : 'dd.MM.yyyy'}} ab.</p>
            <p *ngIf="isDateExpired()" class="is-red">Die Übertragung ist am {{batchDownload.expirationDate | date : 'dd.MM.yyyy'}} abgelaufen.</p>
          </div>
          <div *ngIf="batchDownload" class="mt-5">
            <p>{{batchDownload.name}}</p>
          </div>

          <div>
            <button [ngClass]="{'disabled': downloading } " class="button buy-button is-size-6 has-round-border mt-5"  style="color: white" (click)="downloadBatchFile(batchDownload.id)">
                <p class=" is-bold"> Herunterladen</p>
            </button>

            <div *ngIf="progress > 0 ">
              <progress class="blue mt-3" value="{{ progress }}" max="100"></progress>
              <p>Download Fortschritt: {{ progress }}%</p>
            </div>

          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="column is-one-third"></div>
</div>
